import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dealApi, dealQueryKeys } from "service/crm/api/deal";
import {
  DealKanbanPosition,
  UpdateDealKanbanPositionPayload,
} from "types/crm/deal";


export const useUpdateDealKanbanPositionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      payload: UpdateDealKanbanPositionPayload,
    ): Promise<DealKanbanPosition> => dealApi.updateDealKanbanPosition(payload),
    // Refetch on failure too: every error the API gives here (stale neighbours,
    // a deleted deal, a 409 ordering conflict) means the board is out of date.
    onSettled: (_data, _error, variables) => {
      queryClient.invalidateQueries({ queryKey: dealQueryKeys.all });
      queryClient.invalidateQueries({
        queryKey: dealQueryKeys.detail(variables.dealUuid),
      });
    },
  });
};
